const EMAIL = 'EMAIL';
const SMS = 'SMS';
const TELEMARKETING = 'TELEMARKETING';
const DIRECT_MAIL = 'DIRECT_MAIL';
const PROMOTIONS = 'PROMOTIONS';
const EPC_DESKTOP = 'EPC_DESKTOP';
const EPC_MOBILE = 'EPC_MOBILE';
const EPC_TABLET = 'EPC_TABLET';
const PRO = 'PRO';
export const YES = 'Y';
export const NO = 'N';
export const PENDING = 'P';
const EMAIL_SIGNUP_TEXT = 'To sign up to receive emails from The Home Depot, please'
+ ' provide your email address.';
const SMS_SIGN_UP_TEXT = 'To sign up to receive automated text messages from The Home Depot, '
+ 'please provide your phone number.';
const SMS_SIGNUP_HEADER_TEXT = 'Please Enter Your Phone Number to Sign Up for SMS';
const EMAIL_SIGNUP_HEADER_TEXT = 'Please Enter Your Email Address to Sign Up for Emails';
const EMAIL_FIELD_VALIDATOR_ERROR_TEXT = 'Please provide your email address, formatted as you@domain.com.';
const PHONE_FIELD_VALIDATOR_ERROR_TEXT = 'Phone numbers must be 10 digits.';
const STATES = [
  {
    name: '',
    value: '',
  },
  {
    value: 'AK',
    name: 'AK - Alaska',
  },
  {
    value: 'AL',
    name: 'AL - Alabama',
  },
  {
    value: 'AZ',
    name: 'AZ - Arizona',
  },
  {
    value: 'AR',
    name: 'AR - Arkansas',
  },
  {
    value: 'CA',
    name: 'CA - California',
  },
  {
    value: 'CO',
    name: 'CO - Colorado',
  },
  {
    value: 'CT',
    name: 'CT - Connecticut',
  },
  {
    value: 'DC',
    name: 'DC - District of Columbia',
  },
  {
    value: 'DE',
    name: 'DE - Delaware',
  },
  {
    value: 'FL',
    name: 'FL - Florida',
  },
  {
    value: 'GA',
    name: 'GA - Georgia',
  },
  {
    value: 'HI',
    name: 'HI - Hawaii',
  },
  {
    value: 'IA',
    name: 'IA - Iowa',
  },
  {
    value: 'ID',
    name: 'ID - Idaho',
  },
  {
    value: 'IL',
    name: 'IL - Illinois',
  },
  {
    value: 'IN',
    name: 'IN - Indiana',
  },
  {
    value: 'KS',
    name: 'KS - Kansas',
  },
  {
    value: 'KY',
    name: 'KY - Kentucky',
  },
  {
    value: 'LA',
    name: 'LA - Louisiana',
  },
  {
    value: 'MA',
    name: 'MA - Massachusetts',
  },
  {
    value: 'MD',
    name: 'MD - Maryland',
  },
  {
    value: 'ME',
    name: 'ME - Maine',
  },
  {
    value: 'MI',
    name: 'MI - Michigan',
  },
  {
    value: 'MN',
    name: 'MN - Minnesota',
  },
  {
    value: 'MS',
    name: 'MS - Mississippi',
  },
  {
    value: 'MO',
    name: 'MO - Missouri',
  },
  {
    value: 'MT',
    name: 'MT - Montana',
  },
  {
    value: 'NC',
    name: 'NC - North Carolina',
  },
  {
    value: 'ND',
    name: 'ND - North Dakota',
  },
  {
    value: 'NE',
    name: 'NE - Nebraska',
  },
  {
    value: 'NH',
    name: 'NH - New Hampshire',
  },
  {
    value: 'NJ',
    name: 'NJ - New Jersey',
  },
  {
    value: 'NM',
    name: 'NM - New Mexico',
  },
  {
    value: 'NV',
    name: 'NV - Nevada',
  },
  {
    value: 'NY',
    name: 'NY - New York',
  },
  {
    value: 'OH',
    name: 'OH - Ohio',
  },
  {
    value: 'OK',
    name: 'OK - Oklahoma',
  },
  {
    value: 'OR',
    name: 'OR - Oregon',
  },
  {
    value: 'PA',
    name: 'PA - Pennsylvania',
  },
  {
    value: 'RI',
    name: 'RI - Rhode Island',
  },
  {
    value: 'SC',
    name: 'SC - South Carolina',
  },
  {
    value: 'SD',
    name: 'SD - South Dakota',
  },
  {
    value: 'TN',
    name: 'TN - Tennessee',
  },
  {
    value: 'TX',
    name: 'TX - Texas',
  },
  {
    value: 'UT',
    name: 'UT - Utah',
  },
  {
    value: 'VA',
    name: 'VA - Virginia',
  },
  {
    value: 'VT',
    name: 'VT - Vermont',
  },
  {
    value: 'WA',
    name: 'WA - Washington',
  },
  {
    value: 'WI',
    name: 'WI - Wisconsin',
  },
  {
    value: 'WV',
    name: 'WV - West Virginia',
  },
  {
    value: 'WY',
    name: 'WY - Wyoming',
  },
];
const DO_NOT_WANT_EMAILS = 'I do not wish to receive any communications from '
+ 'The Home Depot in regards to promotional emails.';
const DO_NOT_WANT_SURVEY_EMAILS = 'I do not wish to receive any communications '
+ 'from The Home Depot in regards to survey emails.';
const DO_NOT_WANT_SMS = 'I do not wish to receive any text message promotions from The Home Depot and want '
  + 'to be added to the internal Do Not Call list.';
const TRANSACTIONAL_COMMUNICATION_DISCLAIMER = '*Disclaimer: By checking this box you acknowledge that on occasion,'
+ ' you may receive transactional communications from The Home Depot';
const GENERIC_ERROR = 'We’re sorry, due to technical issues, we were not able to process your request. '
  + 'Please try again later.';

const UPDATE_SUCCESS = 'Success! Your preferences have been updated.';
const SMS_OPT_IN_SUCCESS = `Success! We’ve sent you a text message.
To confirm your request, please respond with a "Y"`;

const FCC_OPTOUT_INFORMATION = 'An opt out of one preference will be treated as an opt out of '
  + 'all three preferences below.';
const ERROR_ALERT_TEXT = 'We\'re unable to process your request. Please try again later.';

const UNSUB_REASON_SUCCESS = 'Success! Your feedback has been recorded.';
const OPTOUT_FEEDBACK_ERROR = 'Something went wrong. Your feedback has not been recorded.';
export const SECURITY_PATH = '/myaccount/security';
export const ADDRESS_PATH = '/myaccount/addresses';
export const PRIVACY_PATH = '/privacy/privacy-and-security-statement';
const PRO_PROMO_PENDING = 'You have requested to receive promotional text messages'
  + ' from The Home Depot but have yet to confirm. Please respond to the text message to '
  + 'complete your request or click “Resend” to receive the text message again.';
const PRO_PENDING = 'You have requested to receive Pro Communications promotional text messages but have yet to'
  + ' confirm. Please respond to the text message to complete your request or click “Resend”'
  + ' to receive a new text message.';
const PROMO_PENDING = 'You have requested to receive The Home Depot promotional text messages but have yet'
  + ' to confirm. Please respond to the text message to complete your request or click “Resend”'
  + ' to receive a new text message.';

export default {
  EMAIL,
  SMS,
  TELEMARKETING,
  DIRECT_MAIL,
  PRO,
  PROMOTIONS,
  STATES,
  DO_NOT_WANT_SMS,
  DO_NOT_WANT_EMAILS,
  DO_NOT_WANT_SURVEY_EMAILS,
  TRANSACTIONAL_COMMUNICATION_DISCLAIMER,
  EPC_DESKTOP,
  EPC_MOBILE,
  EPC_TABLET,
  EMAIL_SIGNUP_TEXT,
  SMS_SIGN_UP_TEXT,
  SMS_SIGNUP_HEADER_TEXT,
  EMAIL_SIGNUP_HEADER_TEXT,
  GENERIC_ERROR,
  EMAIL_FIELD_VALIDATOR_ERROR_TEXT,
  PHONE_FIELD_VALIDATOR_ERROR_TEXT,
  UPDATE_SUCCESS,
  ERROR_ALERT_TEXT,
  UNSUB_REASON_SUCCESS,
  OPTOUT_FEEDBACK_ERROR,
  PRO_PROMO_PENDING,
  PRO_PENDING,
  PROMO_PENDING,
  FCC_OPTOUT_INFORMATION
};
